import { is, isEmpty } from "ramda";

export const isStringWithValue = value => is(String, value) && !isEmpty(value);
